import Button from './Button';

const ConfirmationModal = ({ onConfirm, onClose, title, message, isOpen, isLoading }) => {
  const handleConfirm = () => {
    onConfirm();
  };

  const handleCancel = () => {
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center">
        {/* Overlay */}
        <div className="fixed inset-0 bg-black bg-opacity-40 transition-opacity"></div>

        {/* Modal Content */}
        <div className="relative inline-block w-full max-w-md p-8 my-8 bg-white rounded-xl shadow-lg border border-gray-200 transform transition-all z-10">
          <div className="text-center mb-6">
            <h3 className="text-2xl font-semibold text-gray-800">{title}</h3>
            <p className="text-sm text-gray-600 mt-2">{message}</p>
          </div>

          <div className="flex justify-center space-x-6 mt-6">
            <button
              onClick={handleCancel}
              className="px-6 py-2 text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-300 transition-colors duration-200"
            >
              Cancel
            </button>

            <Button
              onClick={handleConfirm}
              className="px-6 py-2 text-white bg-primary hover:bg-primary rounded-lg focus:outline-none focus:ring-2 focus:ring-primary transition-colors duration-200"
              loading={isLoading}
            >
              Yes
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
